import {
  REQUEST_ADMIN_ACCOUNT,
  REQUEST_ACCOUNT_LIST
} from './mutation-types';

import axiosInst from '@/utility/axiosInst';

export default {
  requestAdminLogin({}, payload) {
    const { username, pwd } = payload
    return axiosInst.springAxiosInst.post("/admin/account/login", { username, pwd })
      .then((res) => {
        localStorage.setItem('adminName' ,res.data.name)
        return res.data;
      })
      .catch(error => {
        console.error('Error during request:', error);
    });
  },

  requestCheckAdmin({}, ) {
    return axiosInst.springAxiosInst.get("/admin/account/check-admin")
    .then((res) => {
      return res.data
    })
  },

  requestAccountList({commit}, payload) {
    const {currentPage, searchType, searchWord, root} = payload
    return axiosInst.springAxiosInst.get("/admin/account/get-account-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord,
        root: root
      }
    }).then((res) => {
      commit(REQUEST_ACCOUNT_LIST, res.data)
    }).catch((err) => {
      console.log(err)
    })
  },

  searchAdminUsername({commit}, payload) {
    const username = payload
    return axiosInst.springAxiosInst.get("/admin/account/search-admin-username", {
      params: {username: username}
    }).then((res) => {
      commit(REQUEST_ADMIN_ACCOUNT, res.data)
      return res.data.result
    })
  },

  requestCreateAccount({}, payload) {
    return axiosInst.springAxiosInst.post("/admin/account/create-account", payload)
      .then((res) => {
        return res.data
      })
  },

  requestCheckDuplicate({}, username) {
    return axiosInst.springAxiosInst.get(`/admin/account/check-username-duplicate/${username}`)
    .then((res) => {
      return res.data
    })
  },

  requestAdminLogout({}) {
    return axiosInst.springAxiosInst.post('/admin/account/logout')
  }
}